import {Container}      from '@/domains/marketing/components/Container';
import {SavvyCalButton} from '@/domains/marketing/components/SavvyCalButton';

export default function CallToAction() {
	return (<div className="bg-white">
		<Container className="py-24 sm:py-32 lg:flex lg:items-center lg:justify-between">
			<h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
				Ready to get started?
				<br />
				Book your engagement today.
			</h2>

			<div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
				<SavvyCalButton color="teal"
				                className="rounded-md bg-teal-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
				>
					Contact us
				</SavvyCalButton>
			</div>
		</Container>
	</div>);
}
